import React from "react";

import { getTotalSweepEntries, handleAssetUrl } from "../../../shared/utils";

export const SocialReferralHeader: React.FC = () => {
  const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
  const { sweepstakeTitle } = window.FKL;
  const totalsweepstakeEntries = getTotalSweepEntries(submission?.data);

  return (
    <div className="social-referral__header">
      <img
        className="social-referral-header-banner__icon"
        src={handleAssetUrl("referral-page-confetti-icon.png")}
        alt="Referral header icon"
      />
      <span className="social-referral-header__title">
        <span className="social-referral-header-text__bold social-referral-gradient__text">
          {`Congrats! You've earned ${totalsweepstakeEntries} ${
            totalsweepstakeEntries > 1 ? "entries" : "entry"
          }`}
        </span>
        {" in the "}
        <br className="mobile-br" />
        <span className="social-referral-header-text__bold">
          {`${sweepstakeTitle}!`}
        </span>
        <br />
        {"Earn even more entries below:"}
      </span>
      <img
        className="social-referral-header-banner__icon flip"
        src={handleAssetUrl("referral-page-confetti-icon.png")}
        alt="Referral header icon"
      />
    </div>
  );
};
